module.exports = __webpack_public_path__ + "static/media/close-lock.278ed1a5.svg";